import React from 'react';
import StampIcon from '@tradera/blueprint/theme/icons2/stamp.svg?jsx';
import PackageIcon from '@tradera/blueprint/theme/icons2/package.svg?jsx';
import { useTranslator } from 'tradera-lang/translate';
import shippingProviders from 'tradera-apps/my-tradera/app/data/shipping-providers';

export const ShippingProviderIcon = ({ providerName, iconClass, imgClass }) => {
    const { t } = useTranslator();
    const { text, logoImgUrl } = shippingProviders.map(t)[providerName];
    return (
        <span title={text}>
            {providerName === 'PostNordStamp' && (
                <StampIcon
                    className={`icon ${iconClass ? iconClass : ''}`.trim()}
                />
            )}
            {providerName === 'PostNordParcel' && (
                <PackageIcon
                    className={`icon ${iconClass ? iconClass : ''}`.trim()}
                />
            )}
            <img
                src={logoImgUrl}
                alt={text}
                className={`${imgClass ? imgClass : ''}`.trim()}
            />
        </span>
    );
};
